import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import FrDatePicker from '../components/FrDatePicker'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import {mCPF, mCNPJ} from '../utils/masks'
import { paramsToObject, formToObject, populateForm, objectToQueryString,swalCarregando } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import { colors } from '@material-ui/core';

const swal = withReactContent(Swal)

function Associado_Curso(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [ano, setAno] = useState()
  const [comboTme, setComboTme] = useState([{ value: '', display: '' }])
  const [comboAno, setComboAno] = useState([{ value: '', display: '' }])
  const [comboAss, setComboAss] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboSas, setComboSas] = useState([{ value: '', display: '' }])
  const [comboCur, setComboCur] = useState([{ value: '', display: '' }])
  const [comboPeridiocidade, setComboPeridiocidade] = useState([{ value: 'M', display: 'Mensal' }, { value: 'A', display: 'Anual' }, { value: 'T', display: 'Todos' }])
  const [comboSit, setComboSit] = useState([{ value: 'S', display: 'Ativo' }, { value: 'N', display: 'Inativo' }])

  const columns = [
    { id: 'associado', numeric: false, label: 'Associado', align: 'left', minWidth: 200 },
    { id: 'formatdata_associacao', numeric: false, label: 'Data Associação', align: 'left', minWidth: 200 },
    { id: 'tipo_mensalidade', numeric: false, label: 'Tipo Mensalidade', align: 'left', minWidth: 200 },
    { id: 'forma_pagamento', numeric: false, label: 'Forma Pagamento', align: 'left', minWidth: 150 },
    { id: 'status', numeric: false, label: 'Situação', align: 'left', minWidth: 150 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swalCarregando(swal)

      setComboTme(await api.getComboData('tipo_mensalidade'))
      setComboCur(await api.getComboData('cursos'))
      setComboFpg(await api.getComboData('forma_pagamento'))
      setComboAss(await api.getComboData('associados'))
      setComboAno([{ value: '2023', display: '2023' },
                   { value: '2024', display: '2024' },
                   { value: '2025', display: '2025' },
                   { value: '2026', display: '2026' },
                   { value: '2027', display: '2027' },
                   { value: '2028', display: '2028' },
                   { value: '2029', display: '2029' },
                   { value: '2030', display: '2030' },
                   { value: '2031', display: '2031' },
                   { value: '2032', display: '2032' }, 
                  ])

      setenableAdd(await api.getAcessos('Termo de Associacao', 'Inclusao'))
      setenableEdit(await api.getAcessos('Termo de Associacao', 'Alteracao'))
      setenableDel(await api.getAcessos('Termo de Associacao', 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // if (!isEmpty(queryObject)) {
    if (true) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/celg/associado_curso?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/associado_curso', { params: queryObject }).then(r => {
        setData(r.data)
        console.log(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/celg/associado_curso');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    switch (e.target.name) {
      case 'ano':
        setAno(e.target.value);
        break;
      default: auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };

  

  const handleChangeModal = (e) => {
    setAno(e.target.value)
  }

  useEffect(() => {
    console.log(ano)
  },[ano])

  // const geraAnuidade = (e) => {
  //   e.preventDefault()
  //   swal.fire({
  //     title: `<h2 style='color:${colors.info900}'>Geração de Anuidades</h2>`,
  //     // html: modalGeracaoAnuidade(),
  //     icon: 'question',
  //     showCancelButton: true,
  //     confirmButtonColor: colors.success500,
  //     cancelButtonColor: colors.danger500,
  //     confirmButtonText: 'Sim',
  //     cancelButtonText: 'Não'
  //   }).then((result) => {
  //     if (result.value) {
  //       api.post('/associado_curso/geraAnuidade', {ano}).then(r => {
  //         console.log(r.data)
  //       })
  //     }
  //   })
  // }


  // filtros por ,  forma de pagamento, periodicidade 
  // ( mensal / anual - combo com os campos pgto_mensal, pgto_anual ou todos ), situacao do associado e ativo;
  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Matrícula</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrSelect
                value={filter.fk_ass || ''}
                style={{ width: 340 }}
                name="fk_ass"
                id="fk_ass"
                label='Associado'
                data={comboAss}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_fpg || ''}
                style={{ width: 170 }}
                name="fk_fpg"
                id="fk_fpg"
                label='Forma de Pagamento'
                data={comboFpg}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.curso || ''}
                style={{ width: 170 }}
                name="curso"
                id="curso"
                label='Curso'
                data={comboCur}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_sas || ''}
                style={{ width: 170 }}
                name="fk_sas"
                id="fk_sas"
                label='Situação Associado'
                data={comboSas}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.situacao || ''}
                style={{ width: 170 }}
                name="situacao"
                id="situacao"
                label='Situação'
                data={comboSit}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/celg/associado_curso/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
                </Link>}
                  {/* <button onClick={geraAnuidade}>
                    <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button> */}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable regName="associado_curso" columns={columns} searched={filtered} codeName="pk_asc" page={'Associado_Curso'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Associado_Curso;
